import React from 'react';
import { useGigPageContext } from '@fiverr-private/gig_page_context';
import { Container, Stack } from '@fiverr-private/layout_components';
import { Typography } from '@fiverr-private/typography';
import { TextButton } from '@fiverr-private/button';
import { type ReviewAttributes } from '@fiverr-private/gig_page_types';
import { ReviewsCarousel } from '@fiverr-private/reviews';
import { appTranslate } from '../../i18n/i18n';
import { BQ_CLICKED_REVIEWS_RATINGS, REVIEWS_SECTION_KEY } from '../../constants';
import { validateReviewsSnippet } from './utils/validateReviewsSnippet';
import { getReviewCarouselProps } from './utils/getReviewCarouselProps';
import { getReviewsSnippetButtonTypographyProps } from './utils/getReviewsSnippetButtonTypographyProps';

export interface ReviewsSnippetProps {
  reviewAttributes: ReviewAttributes;
  isLimitedEdition: boolean;
}

export const ReviewsSnippet = ({ reviewAttributes, isLimitedEdition }: ReviewsSnippetProps) => {
  const { biEvents, sectionScroller, isProRebrandingLayout } = useGigPageContext();

  if (!validateReviewsSnippet({ reviewAttributes, isLimitedEdition })) {
    return null;
  }

  const viewMoreClick = () => {
    biEvents.sendBigQueryEvent({ eventName: BQ_CLICKED_REVIEWS_RATINGS });
    sectionScroller.scroll({ sectionKey: REVIEWS_SECTION_KEY });
  };

  const titleText = appTranslate('reviews_snippet.title');
  const reviewsButtonText = appTranslate('reviews_snippet.view_all');
  const reviewsCarouselProps = getReviewCarouselProps({ reviewAttributes });
  const reviewsButtonTypographyProps = getReviewsSnippetButtonTypographyProps({ isProRebrandingLayout });

  return (
    <Container order={60} display={{ default: 'none', sm: 'block' }}>
      <Stack as="header" width="100%" justifyContent="spaceBetween" paddingBottom="6">
        <Typography as="h2" fontSize="b_xl" lineHeight="b_xl">
          {titleText}
        </Typography>
        <TextButton onClick={viewMoreClick}>
          <Typography {...reviewsButtonTypographyProps}>{reviewsButtonText}</Typography>
        </TextButton>
      </Stack>
      <ReviewsCarousel {...reviewsCarouselProps} />
    </Container>
  );
};
